export const startInvoiceMission = (id) => ({
  type: "START_INVOICE_MISSION",
  id
});



// WEBPACK FOOTER //
// ./src/store/actions/help/invoices.js